import { useContext } from 'react'
import Grid from '@mui/material/Unstable_Grid2/Grid2'

import OneModal from '../OneModal/OneModal'
import { ConexaoServerContext } from '../../Providers/ConexaoServerContext/ConexaoServerContext'

const SnapshotModal = ({ openModal, setOpenModal, cameraId }) => {
    const { getConfigServer } = useContext(ConexaoServerContext)

    const serverConfig = getConfigServer()

    return (
        <OneModal
            open={openModal}
            setOpen={setOpenModal}
            titleText={"Imagem da câmera"}
            fullWidth={true}
            maxWidth='xs'
            onClose={false}
            width='auto'
        >
            <Grid container>
                <img alt="Erro ao buscar imagem." src={`http://${serverConfig.ip}:${serverConfig.porta_api}/monitoramento/getSnapshot?cameraId=${cameraId}`} />
            </Grid>
        </OneModal>
    )
}

export default SnapshotModal
